<div class="mb-3 mt-3 d-flex gap-3">
  <p-button (click)="addTO()" label="Add: To" />

  <p-button (click)="addCC()" label="Add: CC" />
</div>

<p-table
  #dt
  stripedRows
  [value]="contactsList"
  [(selection)]="contactsSelected"
  styleClass="p-datatable-customers order-listing"
  [rowHover]="true"
  [rows]="25"
  [size]="'small'"
  [scrollable]="true"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [paginator]="false"
  [filterDelay]="0"
  dataKey="id"
  editMode="row"
  selectionMode="multiple"
  styleClass="table-listing">
  <ng-template pTemplate="header">
    <tr class="table-head">
      <th class="col-center" style="width: 3rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th class="name">Recipient</th>
      <th class="vaccount">Display name</th>
      <th class="sname">Recipient type</th>
      <th class="sname">Primary</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-addressBookLists let-rowIndex="rowIndex">
    <tr class="p-selectable-row" [pSelectableRow]="addressBookLists">
      <td>
        <p-tableCheckbox
          [value]="addressBookLists"
          [pSelectableRow]="addressBookLists"></p-tableCheckbox>
      </td>
      <td>
        {{ addressBookLists.locatorD365 }}
      </td>
      <td>
        {{ addressBookLists.descriptionD365 }}
      </td>
      <td>
        {{ addressBookLists.purposeD365 }}
      </td>
      <td>
        {{ addressBookLists.isPrimaryD365 | titlecase }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="20">No contacts found.</td>
    </tr>
  </ng-template>
</p-table>
